import type { ReactNode } from "react";
import { AuthProvider } from "@/features/auth";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import { FileViewerProvider } from "@/components/FileViewerDialog";
import { Toaster } from "@/components/ui/sonner";
import { usePreventFileDropNavigation } from "@/hooks/usePreventFileDropNavigation";

export function Providers({ children }: { children: ReactNode }) {
  usePreventFileDropNavigation();
  return (
    <AuthProvider>
      <ConfirmProvider>
        <FileViewerProvider>
          {children}
          <Toaster richColors />
        </FileViewerProvider>
      </ConfirmProvider>
    </AuthProvider>
  );
}
